export const SectionHeading = ({
  children,
  className,
  label,
}: {
  children: React.ReactNode
  className?: string
  label?: string
}) => (
  <div className={`d-flex flex-column mc-text--center ${className || ''}`}>
    <div className='mc-text--uppercase mc-mb-6 mc-text-color--primary'>
      {label}
    </div>
    <h1 className='mc-text-h1'>{children}</h1>
  </div>
)
